import { apiRequest } from './client';
import type {
  Run,
  RunStatus,
  RunStatusReadable,
  RunCounters,
  RunEvent,
} from '@outlinked/shared';

// Re-export canonical types so consumers continue to import from this file
// (preserves the SPA's existing `import { RunStatus } from '../api/runs'`
// pattern without forcing every page to know about `@outlinked/shared`).
export type { Run, RunStatus, RunStatusReadable, RunCounters, RunEvent };

// Admin-api-specific response wrappers. The entity shapes above are
// canonical; only the {items, nextCursor} / {run, events, truncated}
// envelopes are admin-api contract surface and live here.
export interface RunsListResponse {
  items: Run[];
  nextCursor: string | null;
}

export interface RunDetailResponse {
  run: Run;
  events: RunEvent[];
  truncated: boolean;
}

export interface ListRunsOpts {
  cursor?: string;
  limit?: number;
  status?: RunStatus;
}

export function listRuns(opts: ListRunsOpts = {}): Promise<RunsListResponse> {
  const params = new URLSearchParams();
  if (opts.cursor) params.set('cursor', opts.cursor);
  if (opts.limit) params.set('limit', String(opts.limit));
  if (opts.status) params.set('status', opts.status);
  return apiRequest<RunsListResponse>(`/runs?${params}`);
}

export function getRun(id: string): Promise<RunDetailResponse> {
  return apiRequest<RunDetailResponse>(`/runs/${id}`);
}

export function cancelRun(id: string, reason: string): Promise<{ ok: true }> {
  return apiRequest<{ ok: true }>(`/runs/${id}/cancel`, {
    method: 'POST',
    body: JSON.stringify({ reason }),
  });
}

export function replayRun(userId: string, reason: string): Promise<{ ok: true }> {
  return apiRequest<{ ok: true }>(`/users/${userId}/replay`, {
    method: 'POST',
    body: JSON.stringify({ reason }),
  });
}
